import React, { useEffect, useRef } from 'react';

type Prop = {
  callback: () => void;
  children: React.ReactElement<React.HTMLAttributes<HTMLDivElement>>;
};

const DetectOutsideClick = ({ callback, children }: Prop) => {
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (!elementRef.current || !(event.target instanceof Node)) {
        return;
      }

      if (elementRef.current !== event.target && !elementRef.current?.contains(event.target)) {
        callback();
      }
    };

    setTimeout(() => document.addEventListener('click', handleClick), 1);

    return () => document.removeEventListener('click', handleClick);
  }, [callback]);

  return React.cloneElement(children, {
    ref: (node: HTMLDivElement | null) => {
      elementRef.current = node;
    },
  } as React.ClassAttributes<HTMLDivElement>);
};

export default DetectOutsideClick;
